export default {
  avatar: '中文 avatar',
  id: '中文 id',
  code: '中文 code',
  action: '中文 action',
};
